import React, { FC } from 'react';
import { url } from '../Config/Config';
import { Navigate } from 'react-router';

import { getItemFromStorage } from '../utils/Helper';

interface PropType {
    component: React.FC;
}

const PrivateRoute: FC<PropType> = ({ component: Component }) => {
    
    if (getItemFromStorage("is_admin_login_token")) {
        return <Component />;
    }
    else {
        return <Navigate to={url+"/"} />;
    }
};

export default PrivateRoute;